function KnownLocation() {
    "use strict";
    this.__type = 'OrganizationAddress:www.veritracks.com';
    this.Id = -1;
    this.Version = 0;

    this.OrganizationAddressTypeId = -1;
    this.City = '';
    this.Country = '';
    this.State = '';
    this.Street1 = '';
    this.Street2 = '';
    this.Title = '';
    this.Zip = '';
    this.Latitude = 0.00;
    this.Longitude = 0.00;
    this.Radius = 300;
    this.IsActive = 1;
    this.PhoneNumber = '';
    this.OrganizationId = -1;
    this.PositionMatchesGeocode = 1;
    this.Notes = '';
    this.TransactionId = '';
}
if (typeof exports !== 'undefined') {
    module.exports = KnownLocation;
}